import { Container, Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const StyledSkeleton = styled(Skeleton)`
    width: 100%;
    height: 6rem;
`;

export const StyledContainer = styled(Container)`
    padding-bottom: ${getPurpurSpacing('400')};
    padding-top: ${getPurpurSpacing('400')};

    ${purpurMedia('lg')`
        padding-top: ${getPurpurSpacing('600')};
        padding-bottom: ${getPurpurSpacing('600')};
    `}
`;
